<template>
  <div>
    <div class="modal--content">
      <form @submit.prevent="onSubmit">
        <p class="text">{{ $t('oneTwoBuildNotifySales.text') }}</p>
        <p4a-button
          class="acceptButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :fullWidth="true"
          :product="'ds'"
          :size="'large'"
          :text="$t('general.ok')"
          @click="onSubmit"
        ></p4a-button>
      </form>
    </div>
  </div>
</template>

<script>
import * as onetwoBuildApi from 'api/onetwoBuildApi'

export default {
  name: 'oneTwoBuildNotifySales',
  data () {
    return {
    }
  },
  created () {
    onetwoBuildApi.notifySalesOfRequest()
  },
  methods: {
    onSubmit () {
      this.closeWindow()
    },
    closeWindow () {
      window.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.modal--content {
  padding: 16px 24px;

  .text {
    font-size: 13px;
    height: 65px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/oneTwoBuildNotifySales.vue